"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
const SnowplowProvider_1 = require("../SnowplowProvider");
/**
 * Used to set enablePageView and dependencies to default values if none are passed in
 */
const defaultParams = {
    enablePageView: true,
    dependencies: [],
};
/**
 * React app page view event. Uses a React useEffect hook with passed in dependencies to
 * manage the amount of page view calls
 *
 * @param params - object of possible values to pass to this method. Page view is required
 */
const useEnhancedPageView = (params) => {
    const { enablePageView, dependencies, pageName, pageViewContexts } = Object.assign(Object.assign({}, defaultParams), params);
    const { setHasPageViewFired } = (0, react_1.useContext)(SnowplowProvider_1.SnowplowContext);
    const isSnowplowReady = (0, SnowplowProvider_1.useIsSnowplowReady)();
    (0, react_1.useEffect)(() => {
        if (enablePageView && isSnowplowReady) {
            const pageContext = (0, snowplow_js_common_1.pageAttributesContext)(pageName);
            (0, snowplow_js_common_1.addGlobalContexts)([pageContext]);
            (0, snowplow_js_common_1.enhancedPageView)(pageViewContexts);
            setHasPageViewFired(true);
            return () => {
                (0, snowplow_js_common_1.removeGlobalContexts)([pageContext]);
                setHasPageViewFired(false);
            };
        }
    }, [...dependencies, isSnowplowReady]);
};
exports.default = useEnhancedPageView;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRW5oYW5jZWRQYWdlVmlldy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VFbmhhbmNlZFBhZ2VWaWV3LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBQThDO0FBQzlDLGlFQUtrQztBQUNsQywwREFBMEU7QUFHMUU7O0dBRUc7QUFDSCxNQUFNLGFBQWEsR0FBRztJQUNsQixjQUFjLEVBQUUsSUFBSTtJQUNwQixZQUFZLEVBQUUsRUFBRTtDQUNuQixDQUFDO0FBRUY7Ozs7O0dBS0c7QUFDSCxNQUFNLG1CQUFtQixHQUFHLENBQUMsTUFBaUMsRUFBUSxFQUFFO0lBQ3BFLE1BQU0sRUFBRSxjQUFjLEVBQUUsWUFBWSxFQUFFLFFBQVEsRUFBRSxnQkFBZ0IsRUFBRSxtQ0FDM0QsYUFBYSxHQUNiLE1BQU0sQ0FDWixDQUFDO0lBRUYsTUFBTSxFQUFFLG1CQUFtQixFQUFFLEdBQUcsSUFBQSxrQkFBVSxFQUFDLGtDQUFlLENBQUMsQ0FBQztJQUM1RCxNQUFNLGVBQWUsR0FBRyxJQUFBLHFDQUFrQixHQUFFLENBQUM7SUFFN0MsSUFBQSxpQkFBUyxFQUFDLEdBQUcsRUFBRTtRQUNYLElBQUksY0FBYyxJQUFJLGVBQWUsRUFBRTtZQUNuQyxNQUFNLFdBQVcsR0FBRyxJQUFBLDBDQUFxQixFQUFDLFFBQVEsQ0FBQyxDQUFDO1lBRXBELElBQUEsc0NBQWlCLEVBQUMsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDO1lBQ2pDLElBQUEscUNBQWdCLEVBQUMsZ0JBQWdCLENBQUMsQ0FBQztZQUNuQyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUUxQixPQUFPLEdBQUcsRUFBRTtnQkFDUixJQUFBLHlDQUFvQixFQUFDLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQztnQkFDcEMsbUJBQW1CLENBQUMsS0FBSyxDQUFDLENBQUM7WUFDL0IsQ0FBQyxDQUFDO1NBQ0w7SUFDTCxDQUFDLEVBQUUsQ0FBQyxHQUFHLFlBQVksRUFBRSxlQUFlLENBQUMsQ0FBQyxDQUFDO0FBQzNDLENBQUMsQ0FBQztBQUVGLGtCQUFlLG1CQUFtQixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/react/hooks/useEnhancedPageView.ts